(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
(() => {
  let busy = false;
  const base = () => window.Shopify?.routes?.root || '/';
  const host = () => document.querySelector('.mw-cart-page');
  const message = (name) => host()?.dataset[name] || 'No se pudo actualizar. Actualiza la página e inténtalo de nuevo.';
  const lock = (active) => {
    busy = active;
    document.getElementById('MainContent')?.classList.toggle('mw-cart-busy', active);
    document.getElementById('MainContent')?.setAttribute('aria-busy', String(active));
    const checkout = document.getElementById('checkout');
    if (checkout) checkout.disabled = active;
  };
  const request = async (path, body) => {
    const response = await fetch(base() + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error(typeof data.description === 'string' ? data.description : message('error'));
    return data;
  };
  const refresh = () => { window.location.href = (window.routes?.cart_url || base() + 'cart'); };
  document.addEventListener('change', async (event) => {
    const select = event.target.closest('.mw-cart-variant');
    if (!select) return;
    event.stopPropagation();
    const error = document.getElementById(select.getAttribute('aria-describedby'));
    if (busy || select.value === select.dataset.original) return;
    error.hidden = true;
    lock(true);
    let attempted = false;
    let before = 0;
    let oldId = 0;
    let oldQuantity = 0;
    const nextId = Number(select.value);
    try {
      const cart = await request('cart.js');
      const old = cart.items.find(item => item.key === select.dataset.key);
      if (!old || Object.keys(old.properties || {}).length || old.selling_plan_allocation || old.parent_relationship || old.item_components?.length) throw new Error(message('error'));
      const matching = cart.items.filter(item => item.variant_id === nextId);
      if (matching.some(item => Object.keys(item.properties || {}).length || item.selling_plan_allocation || item.parent_relationship || item.item_components?.length)) throw new Error(message('error'));
      before = matching.reduce((total, item) => total + item.quantity, 0);
      oldId = old.variant_id;
      oldQuantity = old.quantity;
      attempted = true;
      await request('cart/add.js', { items: [{ id: nextId, quantity: old.quantity }] });
      const current = await request('cart.js');
      const currentOld = current.items.find(item => item.variant_id === old.variant_id && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation);
      const currentNew = current.items.filter(item => item.variant_id === nextId).reduce((total, item) => total + item.quantity, 0);
      if (!currentOld || currentOld.quantity !== old.quantity || currentNew !== before + old.quantity) throw new Error(message('error'));
      await request('cart/change.js', { id: currentOld.key, quantity: 0 });
      refresh();
    } catch (failure) {
      if (attempted) {
        try {
          const current = await request('cart.js');
          const oldStillPresent = current.items.some(item => item.variant_id === oldId && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation);
          const lines = current.items.filter(item => item.variant_id === nextId && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation);
          const addedQuantity = lines.reduce((total, item) => total + item.quantity, 0);
          if (!oldStillPresent && addedQuantity === before + oldQuantity) { refresh(); return; }
          if (!oldStillPresent) throw new Error(message('review'));
          if (lines.length && addedQuantity !== before) {
            const updates = Object.fromEntries(lines.map((item, index) => [item.key, index === 0 ? before : 0]));
            await request('cart/update.js', { updates });
          }
        } catch (_) {
          error.textContent = message('review');
          error.hidden = false;
          select.value = select.dataset.original;
          lock(false);
          return;
        }
      }
      select.value = select.dataset.original;
      error.textContent = failure.message || message('error');
      error.hidden = false;
      lock(false);
    }
  }, true);
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.mw-cart-reco-form');
    if (!form) {
      if (busy && event.target.id === 'cart') event.preventDefault();
      return;
    }
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const error = form.querySelector('.mw-cart-reco-error');
    error.hidden = true;
    lock(true);
    try {
      const id = Number(new FormData(form).get('id'));
      if (!id) throw new Error(message('choose'));
      await request('cart/add.js', { items: [{ id, quantity: 1 }] });
      refresh();
    } catch (failure) {
      error.textContent = failure.message || message('error');
      error.hidden = false;
      lock(false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
